import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="display-student-info"
export default class extends Controller {
  static targets = [ 'registNumberField', 'studentName' ]
  static values = {
    studentSearchUrl: String,
  }

  connect() {
    const registerNumber = this.registNumberFieldTarget.value
    this.fetchStudentSearch(registerNumber)
  }

  changeStudentInfo(event) {
    const registerNumber = event.target.value
    this.fetchStudentSearch(registerNumber)
  }

  fetchStudentSearch(registerNumber) {
    if (!registerNumber) {
      this.resetStudentInfo()
      return
    }

    const query = new URLSearchParams()
    query.set('q[register_number_eq]', registerNumber)
    fetch(`${this.studentSearchUrlValue}?${query}`)
      .then(response => response.json())
      .then(data => {
        if (data[0]) {
          this.studentNameTarget.innerHTML = data[0].name
        } else {
          this.resetStudentInfo()
        }
      })
  }

  resetStudentInfo() {
    this.studentNameTarget.innerHTML = ''
  }
}
